module.exports = __webpack_public_path__ + "9919c7ea13d21c8d69cfce429512edf6.svg";